import { AIDisclosureModel } from './models/disclosure-model';
import { AIDisclosureModelImpl } from './models/imps/disclosure-model';
import { AIDisclosureService } from './service/disclosure-service';
import { AIDisclosureServiceImpl } from './service/impls/disclosure-service';
import { AIDisclosureResultModel } from './models/disclosure-result-model';
import { AIDisclosureResultModelImpl } from './models/imps/disclosure-result-model';
import { AIDisclosureResultService } from './service/disclosure-result-service';
import { AIDisclosureResultServiceImpl } from './service/impls/disclosure-result-service';
import {
    GetDisclosureTitleDTO,
    GetTechMeansDTO,
    PutDisclosureSettingDTO,
    PutTechMeansDTO,
} from './repository/disclosure-repository';
import { GetDisclosureTitleDTOImpl } from './repository/impls/get-disclosure-title-repository';
import { GetTechMeansDTOImpl } from './repository/impls/get-tech-means-repository';
import { PutDisclosureSettingDTOImpl } from './repository/impls/put-disclosure-setting-repository';
import { PutTechMeansDTOImpl } from './repository/impls/put-tech-means-repository';
import { CheckSensitiveWordService } from '@/services/check-sensitive-word/check-sensitive-word';
import { CheckSensitiveWordServiceImpl } from '@/services/check-sensitive-word/impl/check-sensitive-word';
import { CommandContribution } from '@patsnap/tahiti-core';
import { AddBackgroundContribution } from './service/add-background-command-contribution';
import { AddDrawbacksContribution } from './service/add-drawbacks-command-contribution';
import { AddEffectContribution } from './service/add-effect-command-contribution';
import { AddEmbodimentContribution } from './service/add-embodiment-command-contribution';
import { AddProblemContribution } from './service/add-problem-command-contribution';
import { AddRererenceContribution } from './service/add-reference-command-contribution';
import { expandContribution } from './service/expand-command-contribution';
import { polishContribution } from './service/polish-command-contribution';
import { simplifyContribution } from './service/simplify-command-contribution';
import { DisclosureTaskNameGetter } from './service/disclosure-name-manager';
import { DisclosureTaskNameSetter } from './service/disclosure-name-manager';
import { DisclosureTaskNameManager } from './service/impls/disclosure-name-manager';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { DisclosureFeatureControlService } from './service/disclosure-feature-control-service';
import { DisclosureFeatureControlServiceImpl } from './service/impls/disclosure-feature-control-service-impl';

export const disclosureModule = new ContainerModule((bind) => {
    bind(AIDisclosureModel).to(AIDisclosureModelImpl);
    bind(AIDisclosureService).to(AIDisclosureServiceImpl);
    bind(AIDisclosureResultModel).to(AIDisclosureResultModelImpl);
    bind(AIDisclosureResultService).to(AIDisclosureResultServiceImpl);

    bind(GetDisclosureTitleDTO).to(GetDisclosureTitleDTOImpl);
    bind(GetTechMeansDTO).to(GetTechMeansDTOImpl);
    bind(PutDisclosureSettingDTO).to(PutDisclosureSettingDTOImpl);
    bind(PutTechMeansDTO).to(PutTechMeansDTOImpl);
    bind(CheckSensitiveWordService).to(CheckSensitiveWordServiceImpl);
    bind(DisclosureFeatureControlService).to(DisclosureFeatureControlServiceImpl);

    bind(DisclosureTaskNameManager).toSelf();
    bind(DisclosureTaskNameGetter).toService(DisclosureTaskNameManager);
    bind(DisclosureTaskNameSetter).toService(DisclosureTaskNameManager);

    //contributions
    bind(CommandContribution).to(AddBackgroundContribution);
    bind(CommandContribution).to(AddDrawbacksContribution);
    bind(CommandContribution).to(AddEffectContribution);
    bind(CommandContribution).to(AddEmbodimentContribution);
    bind(CommandContribution).to(AddProblemContribution);
    bind(CommandContribution).to(AddRererenceContribution);
    bind(CommandContribution).to(expandContribution);
    bind(CommandContribution).to(polishContribution);
    bind(CommandContribution).to(simplifyContribution);
});

